export default "__VITE_ASSET__DdNnmHW0__"